module.exports = __webpack_public_path__ + "img/accepted_cards.cc111adc.png";